export default "__VITE_ASSET__C$$r97Ku__"